export default __webpack_public_path__ + "static/media/icon_privacy_home_transparency_base.39d3d223.svg";